import { render, staticRenderFns } from "./MemberListByLabel.vue?vue&type=template&id=340f39b0&scoped=true"
import script from "./MemberListByLabel.vue?vue&type=script&lang=js"
export * from "./MemberListByLabel.vue?vue&type=script&lang=js"
import style0 from "./MemberListByLabel.vue?vue&type=style&index=0&id=340f39b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f39b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340f39b0')) {
      api.createRecord('340f39b0', component.options)
    } else {
      api.reload('340f39b0', component.options)
    }
    module.hot.accept("./MemberListByLabel.vue?vue&type=template&id=340f39b0&scoped=true", function () {
      api.rerender('340f39b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/member_label/MemberListByLabel.vue"
export default component.exports